import { ActionSheet } from 'vant'
import { addPortNode } from '../port'
import { h } from '@vue/composition-api'

export function showActionSheet(
  data: Array<{
    label: string
    onClick: () => any
  }>,
) {
  const destroy = addPortNode(
    h({
      data: () => ({
        visible: false,
      }),

      mounted() {
        // @ts-ignore
        this.visible = true
      },

      render() {
        return h(ActionSheet, {
          props: {
            value: this.visible,
            actions: data.map(item => ({
              ...item,
              name: item.label,
            })),
            cancelText: '取消',
            closeOnClickAction: true,
            lazyRender: false,
          },
          on: {
            input: (visible: boolean) => {
              if (!visible) {
                // @ts-ignore
                this.visible = false
                setTimeout(destroy, 4000)
              }
            },
            select: (item: typeof data[0]) => item.onClick(),
          },
        })
      },
    }),
  )
}
